import { html } from 'lit-element';
import { ifNotNull } from '../../utils/directives';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './breadcrumb-item.lit.scss';

/**
 * @component {kat-breadcrumb-item} KatalBreadcrumbItem Breadcrumbs is a graphical control element used as a navigational aid in user interfaces. It allows users to keep track of their locations within websites.
 * @guideline Do Use "kat-breadcrumb-item" children.
 * @example SetViaHtml {"content": "<kat-breadcrumb-item label=\"Parent\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Group\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Category\" href=\"#\"></kat-breadcrumb-item><kat-breadcrumb-item label=\"Current Category\" href=\"#\"></kat-breadcrumb-item>"}
 * @status Production
 * @theme flo
 */
@register('kat-breadcrumb-item')
export class KatalBreadcrumbItem extends KatLitElement {
  static get properties() {
    return {
      /**
       * @required
       * @classprop {string} label This is the label of your breadcrumb item
       */
      label: { type: String, reflect: true },

      /**
       * @required
       * @classprop {string} href This is the link where the breadcrumb item leads
       */
      href: { type: String, reflect: true },
    };
  }

  static get styles() {
    return [baseStyles, styles];
  }

  render() {
    return html`
      <div class="item">
        <span part="breadcrumb-item-label" class="label" last
          >${ifNotNull(this.label)}</span
        >
        <kat-link
          class="link"
          part="breadcrumb-item-link"
          href="${ifNotNull(this.href)}"
          label="${ifNotNull(this.label)}"
        ></kat-link>
        <kat-icon
          class="separator"
          part="breadcrumb-item-icon"
          name="chevron-right"
        ></kat-icon>
      </div>
    `;
  }
}
